export default __webpack_public_path__ + "static/pragicts-ai-travel-7974b8861726a9c9a0ded594656e031b.jpg";